import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesEdocs.vue?vue&type=template&id=dbdf37e0"
import script from "./LicitacaoAtualizacaoAcoesEdocs.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesEdocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports